import React, { Component } from 'react';
import styled from 'styled-components';
import orderBy from 'lodash/orderBy';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import { Card, CardText, CardHeader, CardActions } from 'material-ui/Card';
import SelectField from 'material-ui/SelectField';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
// import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
// import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import { database } from '../../utils/configureFirebase';
import csvConverter from '../../utils/CandidateCSV';
import { theme } from '../../utils/getTheme';
import CandidateTableCard from '../../components/CandidateTableCard';

const myanatomy = 'MA#CSV#PASSWORD';
const ContentWrapper = styled.div`
  width: 90%;
  margin: 0 auto;

  & > * + * {
    margin-top: 24px;
  }
`;

const LoaderWrapper = styled.div`text-align: center;`;

const DataWrapper = styled.div`
  display: flex;
  flex: wrap;
  justify-content: space-between;
  width: 100%;
  & > * + * {
    widht: 40%;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ContentContainer = styled.div`
  & > * {
    margin-top: 24px;
  }
`;

const AddressContainer = styled.div`width: 60%;`;

class CollegeStudentView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      selectedCollege: '',
      collegeData: undefined,
      studentData: undefined,
      passwordErrorText: undefined,
      password: '',
      csvConfirmationModal: false,
    };
  }

  componentDidMount() {
    this.collegeRef = database.ref('contact/college');
    this.collegeRef.on('value', this.setCollegeData);
  }

  setCollegeData = (snapshot) => {
    if (snapshot) {
      this.setState(() => ({
        collegeData: snapshot.val(),
        isLoading: false,
      }));
    }
  };

  getCollegeData = (collegeData) => {
    if (typeof collegeData !== 'undefined') {
      const collegeArr = Object.keys(collegeData).map((collegeId) => {
        const data = collegeData[collegeId];
        return {
          ...data,
          collegeId,
        };
      });
      return orderBy(collegeArr, college => college.collegeName, 'asc');
    }

    return [];
  };

  setStudentData = (snapshot) => {
    if (snapshot) {
      this.setState(() => ({
        studentData: snapshot.val(),
        isLoading: false,
      }));
    }
  };

  getStudentData = (studentData) => {
    if (typeof studentData !== 'undefined' && studentData) {
      const studentArr = Object.keys(studentData).map((studentId) => {
        const data = studentData[studentId];
        return {
          ...data,
          studentId,
        };
      });
      return orderBy(studentArr, student => student.timestamp, 'asc');
    }
    return [];
  };

  getUniqueData = (studentData, fieldName) => {
    const data = studentData.map(row => get(row, fieldName));
    const uniqueData = uniq(data.sort().map(val => val));

    return uniqueData;
  };

  fetchStudentData = (collegeId) => {
    this.setState(() => ({
      isLoading: true,
    }));
    this.studentRef = database.ref(`contact/candidate/${collegeId}`);
    this.studentRef.on('value', this.setStudentData);
  };

  openCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: true,
      passwordErrorText: undefined,
      password: '',
    }));
  };

  closeCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: false,
    }));
  };

  downloadCSV = (candidateRegistrations, collegeName) => {
    const { password } = this.state;
    if (password === myanatomy) {
      csvConverter(candidateRegistrations, `EB-${collegeName}`);
      this.setState(() => ({
        csvConfirmationModal: false,
      }));
    } else {
      this.setState(() => ({
        passwordErrorText: 'PasswordMismatch',
      }));
    }
  };

  render() {
    const {
      isLoading,
      selectedCollege,
      collegeData,
      studentData,
      password,
      passwordErrorText,
      csvConfirmationModal,
      drawerOpen,
    } = this.state;
    const studentRegistrations = this.getStudentData(studentData);
    return (
      <div>
        {isLoading ? (
          <ContentWrapper>
            <LoaderWrapper>
              <CircularProgress />
            </LoaderWrapper>
          </ContentWrapper>
        ) : (
          <ContentWrapper>
            <Card>
              <CardHeader
                title="Select College"
                titleColor={theme.primary1Color}
                style={{ paddingBottom: 0 }}
              />
              <CardText style={{ paddingTop: 0 }}>
                <SelectField
                  floatingLabelText="Select College"
                  hintText="Select college to see student data"
                  fullWidth
                  value={selectedCollege}
                  onChange={(_, index, value) => {
                    this.setState(() => ({
                      selectedCollege: value,
                    }));
                    this.fetchStudentData(value);
                  }}
                >
                  {this.getCollegeData(collegeData).map(college => (
                    <MenuItem
                      key={college.collegeId}
                      value={college.collegeId}
                      primaryText={`${college.collegeName}, ${college.state}, ${college.city}`}
                    />
                  ))}
                </SelectField>
                {selectedCollege ? (
                  <DataWrapper>
                    <AddressContainer>
                      <CardHeader title="Address" style={{ paddingLeft: 0 }} />
                      {`${collegeData[selectedCollege].address}, ${collegeData[
                        selectedCollege
                      ].city}, ${collegeData[selectedCollege].state}`}
                    </AddressContainer>
                    <div>
                      {studentData ? (
                        <CardHeader
                          title={`No of Registerations: ${studentRegistrations.length}`}
                        />
                      ) : null}
                    </div>
                  </DataWrapper>
                ) : null}
              </CardText>
            </Card>
            {studentRegistrations.length !== 0 ? (
              <ContentContainer>
                {studentData ? (
                  <div>
                    <ButtonContainer>
                      <CardActions>
                        {/* <IconButton>
                            <FilterIcon
                              color={theme.primary1Color}
                              onTouchTap={() => {
                                this.setState(state => ({
                                  drawerOpen: !state.drawerOpen,
                                }));
                              }}
                            />
                          </IconButton> */}
                        <RaisedButton
                          label="Download CSV"
                          primary
                          onTouchTap={() => {
                            // this.openCSVConfirmationModal
                            csvConverter(
                              studentRegistrations,
                              `EB-${collegeData[selectedCollege].collegeName}`,
                            );
                          }}
                        />
                      </CardActions>
                    </ButtonContainer>
                    <CandidateTableCard studentData={studentRegistrations} />
                  </div>
                ) : (
                  <Card>
                    <CardText color={theme.accent1Color}>
                      There are no student records for this college
                    </CardText>
                  </Card>
                )}
              </ContentContainer>
            ) : null}
          </ContentWrapper>
        )}
        <Dialog
          title="Download"
          modal
          actions={[
            <FlatButton
              label="Cancel"
              primary
              onTouchTap={this.closeCSVConfirmationModal}
            />,
            <RaisedButton
              label="Download"
              primary
              onTouchTap={() => {
                this.downloadCSV(
                  studentRegistrations,
                  collegeData[selectedCollege].collegeName,
                );
              }}
            />,
          ]}
          onRequestClose={this.closeCSVConfirmationModal}
          open={csvConfirmationModal}
        >
          <CardText>
            <TextField
              floatingLabelText="Please Enter password to Download"
              type="password"
              value={password}
              onChange={(_, value) => {
                this.setState(() => ({
                  password: value,
                }));
              }}
              errorText={passwordErrorText}
            />
          </CardText>
        </Dialog>
        <Drawer
          containerStyle={{ top: 64 }}
          openSecondary
          width={216}
          docked={false}
          open={drawerOpen}
          onRequestChange={(open) => {
            this.setState(() => ({
              drawerOpen: open,
            }));
          }}
        >
          <Card zDepth={0}>
            <CardHeader
              title="Filters"
              style={{ backgroundColor: theme.primary3Color }}
            />
            <CardHeader
              title="Select States"
              titleColor={theme.primary1Color}
              actAsExpander
              showExpandableButton
            />
            <CardText expandable>
              {/* {states.map(state => (
                <Checkbox
                  key={state.name}
                  label={state.name}
                  onCheck={(_, checked) => {
                    // if (checked) {
                    //  this.addFilter(state.value, collegeRegisterations);
                    // } else {
                    //   this.removeFilter(state.value);
                    // }
                  }}
                />
              ))} */}
            </CardText>
          </Card>
        </Drawer>
      </div>
    );
  }
}

export default CollegeStudentView;



// WEBPACK FOOTER //
// ./src/views/CollegeStudentView/CollegeStudentView.js